import { dataService } from '../../data';
import { AppConstants } from '@unpispas/upp-defs';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Place } from './place';
import { OfferView, OfferViewProxy } from '../views/offer';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PlaceType } from '../types';
import { OfferProductType } from '../types';
import { OfferPeriodType } from '../types';
import { I18nValueType } from '../types';

const _schema = {
    "name": "OFFER",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "place", type: "objid" },
        { name: "name", type: "objid" },
        { name: "photo", type: "file" },
        { name: "description", type: "objid" },
        { name: "price", type: "number" },
        { name: "ismenu", type: "boolean" },
        { name: "allday", type: "boolean" }
    ],
    relate: [
        { direction: ">", target: "PLACE", by: "place", name: "place", reason: "place", child: false, class: PlaceType },
        { direction: ">", target: "I18NVALUE", by: "name", name: "name", reason: "name", child: true, class: I18nValueType },
        { direction: ">", target: "I18NVALUE", by: "description", name: "description", reason: "description", child: true, class: I18nValueType },
        { direction: "<", target: "OFFERPRODUCT", by: "offer", name: "product", reason: "products", child: true, class: OfferProductType },
        { direction: "<", target: "OFFERPERIOD", by: "offer", name: "period", reason: "periods", child: true, class: OfferPeriodType },
    ]
} as const;

const _OfferClass = CreateObject(_schema);
if (!_OfferClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class Offer extends _OfferClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): Offer {
        return this._Copy(store) as Offer;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'place' && related instanceof Place){
            if (related === this.place){
                related.AddOffer(this);
            }
        }
    }

    override get viewProxy(): OfferView {
        return OfferViewProxy(this, this.data);
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get avatar(): string | null {
        const _bg = 'd3c79b';
        const _fg = '000000';

        const _lb = this.name?.tr() ?? null;
        if (!_lb){
            return null;
        }

        return AppConstants.baseURL + 'photo/avatar?size=128&background=' + _bg + '&color=' + _fg + '&name=' + encodeURIComponent(_lb);
    }

    get photo(): string | null {
        return this['__base__photo'] || this.avatar;
    }

    set photo(value: string | null) {
        this['__base__photo'] = value;
    }

    get status(): string | null {
        return this['__base__status']
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.place){
            if ((this.status == 'DE') && !this.Commited){
                this.place.DelOffer(this);
            }
            else {
                this.place.DoRefresh(this.table);
            }    
        }
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}

